import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { ICreateProdutoBody, IProduto } from 'src/app/services/ProdutoService/produto.model';
import { ProdutoService } from 'src/app/services/ProdutoService/produto.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import {
  STATUS_PRODUTO_OPTIONS,
  UNIDADE_MEDIDA_OPTIONS
} from '../../estoque.constants';

@Component({
  selector: 'app-cadastro-produto',
  templateUrl: './cadastro-produto.component.html',
  styleUrls: ['./cadastro-produto.component.scss']
})
export class CadastroProdutoComponent implements OnInit {
  form: FormGroup;
  title = 'Cadastro de Produto';
  isEditing = false;
  isLoading = false;
  disabledForm = false;
  pkProduto = 0;
  guid = generateUUID();

  unidadeOptions = UNIDADE_MEDIDA_OPTIONS;
  statusOptions = STATUS_PRODUTO_OPTIONS;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private produtoService: ProdutoService,
    public swalAlert: SwalAlertService
  ) {
    this.form = this.initForm();
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['codigo']) {
        this.pkProduto = Number(params['codigo']);
        this.isEditing = params['modoProduto'] === 'Editar';
        this.disabledForm = params['modoProduto'] === 'Visualizar';
        this.title = this.disabledForm
          ? 'Visualizar Produto'
          : this.isEditing
            ? 'Editar Produto'
            : 'Cadastro de Produto';
        this.loadProduto(this.pkProduto);
        if (this.disabledForm) {
          this.form.disable();
        }
      }
    });
  }

  initForm(): FormGroup {
    return this.fb.group({
      NM_PROD: ['', Validators.required],
      TX_DESC: [''],
      VL_UNIT: [0, [Validators.required, Validators.min(0)]],
      NU_UNID_MED: [1, Validators.required],
      NU_STTS: [1, Validators.required],
      QT_ESTQ_MIN: [0, [Validators.required, Validators.min(0)]]
    });
  }

  loadProduto(id: number): void {
    this.isLoading = true;
    this.produtoService.GetProdutoById(id).subscribe({
      next: (response: IProduto) => {
        this.form.patchValue({
          NM_PROD: response.NM_PROD,
          TX_DESC: response.TX_DESC ?? '',
          VL_UNIT: response.VL_UNIT,
          NU_UNID_MED: response.NU_UNID_MED,
          NU_STTS: response.NU_STTS,
          QT_ESTQ_MIN: response.QT_ESTQ_MIN
        });
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  onSelectChange(event: number | string | null, name: string): void {
    const value =
      event === null || event === undefined || event === ''
        ? null
        : Number(event);
    this.form.controls[name].setValue(
      value !== null && Number.isNaN(value) ? null : value
    );
  }

  postarDados(): void {
    if (!this.form.valid) {
      this.swalAlert.showAlert(
        'Atenção!',
        'Verifique os campos obrigatórios.',
        'warning'
      );
      return;
    }

    const raw = this.form.getRawValue();
    const payload: ICreateProdutoBody = {
      NM_PROD: String(raw.NM_PROD ?? '').trim(),
      TX_DESC: String(raw.TX_DESC ?? '').trim(),
      VL_UNIT: Number(raw.VL_UNIT),
      NU_UNID_MED: Number(raw.NU_UNID_MED),
      NU_STTS: Number(raw.NU_STTS),
      QT_ESTQ_MIN: Number(raw.QT_ESTQ_MIN)
    };
    this.isLoading = true;

    if (this.isEditing) {
      this.produtoService.UpdateProduto(this.pkProduto, payload).subscribe({
        next: () => {
          this.isLoading = false;
          this.router.navigate(['listagem/estoque/produtos']);
        },
        error: () => {
          this.isLoading = false;
        }
      });
      return;
    }

    this.produtoService.CreateProduto(payload, this.guid).subscribe({
      next: () => {
        this.isLoading = false;
        this.router.navigate(['listagem/estoque/produtos']);
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }
}
